import { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import { formatCurrency, formatPercent } from './radarUtils';

const EvolucaoRadarPage = () => {
  const [dias, setDias] = useState(90);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    serie: [],
    tendencias: {},
    recorrencia_ruptura_secao: [],
    tempo_medio_resolucao_min: [],
    volatilidade_margem_por_secao: [],
    taxa_resolucao_semanal_pct: null,
    valor_potencial_recuperavel: 0,
  });

  const loadData = async () => {
    try {
      setLoading(true);
      const rs = await axios.get('/api/radar-lucro/evolucao', { params: { dias } });
      setData(rs.data || {});
    } catch (error) {
      toast.error(error.response?.data?.error || 'Erro ao carregar evolução');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, [dias]);

  const ultimo = useMemo(() => {
    const serie = data?.serie || [];
    return serie.length ? serie[serie.length - 1] : null;
  }, [data]);

  return (
    <div className="animate-fade-in space-y-4">
      <div className="rounded-xl border border-primary-200 bg-primary-50 p-4">
        <p className="text-sm font-semibold text-primary-800">Evolução histórica do Radar</p>
        <p className="text-2xl font-bold text-primary-900 mt-1">Sinais de tendência e recorrência em {dias} dias</p>
        <p className="text-sm text-primary-800 mt-1">Aqui você valida progresso real e não apenas foto do dia.</p>
      </div>

      <div className="flex items-center gap-3">
        <select className="form-select w-48" value={dias} onChange={(e) => setDias(Number(e.target.value))}>
          <option value={30}>Últimos 30 dias</option>
          <option value={90}>Últimos 90 dias</option>
          <option value={180}>Últimos 180 dias</option>
          <option value={365}>Últimos 365 dias</option>
        </select>
        <button className="btn-secondary" onClick={loadData} disabled={loading}>
          Atualizar
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
        <div className="card"><div className="card-body"><p className="text-sm text-gray-500">Risco atual</p><p className="text-2xl font-bold text-danger-700">{formatCurrency(ultimo?.risco_7d_total)}</p></div></div>
        <div className="card"><div className="card-body"><p className="text-sm text-gray-500">Capital parado atual</p><p className="text-2xl font-bold text-warning-700">{formatCurrency(ultimo?.capital_parado_total)}</p></div></div>
        <div className="card"><div className="card-body"><p className="text-sm text-gray-500">Concentração de risco</p><p className="text-2xl font-bold text-gray-900">{formatPercent(data?.tendencias?.concentracao_risco_pct)}</p></div></div>
        <div className="card"><div className="card-body"><p className="text-sm text-gray-500">Taxa resolução semanal</p><p className="text-2xl font-bold text-success-700">{data?.taxa_resolucao_semanal_pct === null ? '-' : formatPercent(data?.taxa_resolucao_semanal_pct)}</p></div></div>
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
        <div className="card">
          <div className="card-header"><h3 className="text-lg font-semibold">Recorrência de ruptura por seção</h3></div>
          <div className="card-body p-0">
            <div className="table-container">
              <table className="table">
                <thead><tr><th>Seção</th><th>Recorrências</th></tr></thead>
                <tbody>
                  {(data?.recorrencia_ruptura_secao || []).map((r) => (
                    <tr key={r.secao}><td>{r.secao}</td><td>{r.recorrencias}</td></tr>
                  ))}
                  {!(data?.recorrencia_ruptura_secao || []).length && <tr><td colSpan={2} className="text-center text-gray-500 py-6">Sem dados no período.</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header"><h3 className="text-lg font-semibold">Tempo médio de resolução</h3></div>
          <div className="card-body p-0">
            <div className="table-container">
              <table className="table">
                <thead><tr><th>Tipo</th><th>Minutos</th></tr></thead>
                <tbody>
                  {(data?.tempo_medio_resolucao_min || []).map((r) => (
                    <tr key={r.alert_type}><td>{r.alert_type}</td><td>{r.avg_duration_min}</td></tr>
                  ))}
                  {!(data?.tempo_medio_resolucao_min || []).length && <tr><td colSpan={2} className="text-center text-gray-500 py-6">Sem resoluções no período.</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <p className="text-sm text-gray-500">Valor potencial recuperável (resoluções no período)</p>
          <p className="text-2xl font-bold text-success-700">{formatCurrency(data?.valor_potencial_recuperavel)}</p>
        </div>
      </div>
    </div>
  );
};

export default EvolucaoRadarPage;
